/**
 * After Sales Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Viettel Post webhook DATA payload (order/status info)
 */
export interface ViettelPostWebhookPayloadDTO { 
    orderStatusDateAsInstant?: string;
    ORDER_NUMBER?: string;
    ORDER_REFERENCE?: string;
    ORDER_STATUS?: ViettelPostWebhookPayloadDTO.ORDERSTATUSEnum;
    STATUS_NAME?: string;
    ORDER_STATUSDATE?: string;
    NOTE?: string;
    MONEY_COLLECTION?: number;
    MONEY_FEECOD?: number;
    MONEY_TOTAL?: number;
    EXPECTED_DELIVERY?: string;
    PRODUCT_WEIGHT?: number;
    ORDER_SERVICE?: string;
}
export namespace ViettelPostWebhookPayloadDTO {
    export const ORDERSTATUSEnum = {
        _101: '101',
        _102: '102',
        _103: '103',
        _104: '104',
        _105: '105',
        _107: '107',
        _200: '200',
        _201: '201',
        _202: '202',
        _300: '300',
        _400: '400',
        _500: '500',
        _501: '501',
        _502: '502',
        _503: '503',
        _504: '504',
        _505: '505',
        _506: '506',
        _507: '507',
        _508: '508',
        _509: '509',
        _515: '515',
        _550: '550'
    } as const;
    export type ORDERSTATUSEnum = typeof ORDERSTATUSEnum[keyof typeof ORDERSTATUSEnum];
}


